export default __webpack_public_path__ + "static/media/carro-de-la-compra-1.eb0cd808.svg";